export default __webpack_public_path__ + "build/26d8fb317185c508d3ed7a3a3737944c.svg";